module.exports = __webpack_public_path__ + "img/icon-zuzhigoujia.606cfd8e.svg";